import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'were_other_wage_payments_line_legal_requirements'

export const dataPointDefinition = {
  retracedId: 'were_other_wage_payments_line_legal_requirements',
  name: 'Were all OTHER wage payments in line with legal requirements?',
  description:
    'The intent of this question is to understand if the facility pays workers correctly for all OTHER benefits not specifically mentioned in the preceding questions in line with applicable legal requirements (e.g. attendance or other bonuses, transportation or housing allowances, seniority indemnity for',
  meta: {
    slcpMeta: {
      key: 'wb-26',
      number: 'WB-WAGE-153',
      masterType: 'Question',
      versionImported: '1.7.0',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'wb-26', version: '1.7.0', provider: 'slcp'}],
  sortingId: 35460,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
